module.exports = __webpack_public_path__ + "static/media/12a.3eee9725.jpeg";